const actions = {
  CHECK_AUTH_REQUEST: "ADMIN_CHECK_AUTH_REQUEST",
  CHECK_AUTH_SUCCESS: "ADMIN_CHECK_AUTH_SUCCESS",
  CHECK_AUTH_FAILED: "ADMIN_CHECK_AUTH_FAILED",
  SIGN_IN_REQUEST: "ADMIN_SIGN_IN_REQUEST",
  SIGN_IN_SUCCESS: "ADMIN_SIGN_IN_SUCCESS",
  SIGN_IN_FAILED: "ADMIN_SIGN_IN_FAILED",
  SIGN_OUT_REQUEST: "ADMIN_SIGN_OUT_REQUEST",
  SIGN_OUT_SUCCESS: "ADMIN_SIGN_OUT_SUCCESS",
  FETCH_DASHBOARD_REQUEST: "ADMIN_FETCH_DASHBOARD_REQUEST",
  FETCH_DASHBOARD_SUCCESS: "ADMIN_FETCH_DASHBOARD_SUCCESS",
  FETCH_DASHBOARD_FAILED: "ADMIN_FETCH_DASHBOARD_FAILED",
  FETCH_USERS_REQUEST: "ADMIN_FETCH_USERS_REQUEST",
  FETCH_USERS_SUCCESS: "ADMIN_FETCH_USERS_SUCCESS",
  FETCH_USERS_FAILED: "ADMIN_FETCH_USERS_FAILED",
  FETCH_USER_REQUEST: "ADMIN_FETCH_USER_REQUEST",
  FETCH_USER_SUCCESS: "ADMIN_FETCH_USER_SUCCESS",
  FETCH_USER_FAILED: "ADMIN_FETCH_USER_FAILED",
  CLEAR_USER_DETAIL: "ADMIN_CLEAR_USER_DETAIL",
  UPDATE_USER_REQUEST: "ADMIN_UPDATE_USER_REQUEST",
  EXTEND_TRIAL_REQUEST: "ADMIN_EXTEND_TRIAL_REQUEST",
  DELETE_USER_REQUEST: "ADMIN_DELETE_USER_REQUEST",
  FETCH_ORGANIZATIONS_REQUEST: "ADMIN_FETCH_ORGANIZATIONS_REQUEST",
  FETCH_ORGANIZATIONS_SUCCESS: "ADMIN_FETCH_ORGANIZATIONS_SUCCESS",
  FETCH_ORGANIZATIONS_FAILED: "ADMIN_FETCH_ORGANIZATIONS_FAILED",
  FETCH_ORGANIZATION_REQUEST: "ADMIN_FETCH_ORGANIZATION_REQUEST",
  FETCH_ORGANIZATION_SUCCESS: "ADMIN_FETCH_ORGANIZATION_SUCCESS",
  FETCH_ORGANIZATION_FAILED: "ADMIN_FETCH_ORGANIZATION_FAILED",
  CREATE_ORGANIZATION_REQUEST: "ADMIN_CREATE_ORGANIZATION_REQUEST",
  UPDATE_ORGANIZATION_REQUEST: "ADMIN_UPDATE_ORGANIZATION_REQUEST",
  INVITE_ORGANIZATION_REQUEST: "ADMIN_INVITE_ORGANIZATION_REQUEST",
  RESEND_INVITATION_REQUEST: "ADMIN_RESEND_INVITATION_REQUEST",
  DELETE_MEMBER_REQUEST: "ADMIN_DELETE_MEMBER_REQUEST",
  ISSUE_INVOICE_REQUEST: "ADMIN_ISSUE_INVOICE_REQUEST",
  FETCH_INTELLIGENCE_COSTS_REQUEST: "ADMIN_FETCH_INTELLIGENCE_COSTS_REQUEST",
  FETCH_INTELLIGENCE_COSTS_SUCCESS: "ADMIN_FETCH_INTELLIGENCE_COSTS_SUCCESS",
  FETCH_INTELLIGENCE_COSTS_FAILED: "ADMIN_FETCH_INTELLIGENCE_COSTS_FAILED",
  MUTATION_SUCCESS: "ADMIN_MUTATION_SUCCESS",
  MUTATION_FAILED: "ADMIN_MUTATION_FAILED",
  CLEAR_FEEDBACK: "ADMIN_CLEAR_FEEDBACK",

  checkAuth: () => ({ type: actions.CHECK_AUTH_REQUEST }),
  signIn: (email, password) => ({ type: actions.SIGN_IN_REQUEST, email, password }),
  signOut: () => ({ type: actions.SIGN_OUT_REQUEST }),
  fetchDashboard: () => ({ type: actions.FETCH_DASHBOARD_REQUEST }),
  fetchUsers: (params = {}) => ({ type: actions.FETCH_USERS_REQUEST, params }),
  fetchUser: (id) => ({ type: actions.FETCH_USER_REQUEST, id }),
  clearUserDetail: () => ({ type: actions.CLEAR_USER_DETAIL }),
  updateUser: (id, user, params = {}, feedback) => ({
    type: actions.UPDATE_USER_REQUEST, id, user, params, feedback,
  }),
  extendTrial: (id, days, reason, params = {}) => ({type: actions.EXTEND_TRIAL_REQUEST, id, days, reason, params}),
  deleteUser: (id, displayName, params = {}) => ({
    type: actions.DELETE_USER_REQUEST, id, displayName, params,
  }),
  fetchOrganizations: (params = { per_page: 100 }) => ({
    type: actions.FETCH_ORGANIZATIONS_REQUEST, params,
  }),
  fetchOrganization: (id) => ({ type: actions.FETCH_ORGANIZATION_REQUEST, id }),
  createOrganization: (organization) => ({ type: actions.CREATE_ORGANIZATION_REQUEST, organization }),
  updateOrganization: (id, organization, displayName) => ({
    type: actions.UPDATE_ORGANIZATION_REQUEST, id, organization, displayName,
  }),
  inviteOrganization: (id, invite, source = "list") => ({
    type: actions.INVITE_ORGANIZATION_REQUEST, id, invite, source,
  }),
  resendInvitation: (organizationId, inviteId, email, source = "users") => ({
    type: actions.RESEND_INVITATION_REQUEST, organizationId, inviteId, email, source,
  }),
  deleteMember: (organizationId, userId, displayName) => ({
    type: actions.DELETE_MEMBER_REQUEST, organizationId, userId, displayName,
  }),
  issueInvoice: (id, invoice) => ({ type: actions.ISSUE_INVOICE_REQUEST, id, invoice }),
  fetchIntelligenceCosts: (params) => ({ type: actions.FETCH_INTELLIGENCE_COSTS_REQUEST, params }),
  clearFeedback: () => ({ type: actions.CLEAR_FEEDBACK }),
};

export default actions;
